import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListCraClientFinalComponent } from './components/list-cra-client-final/list-cra-client-final.component';
import { DetailsCraCandidatComponent } from './components/details-cra-candidat/details-cra-candidat.component';
import { MonthlyListCraComponent } from './components/monthly-list-cra/monthly-list-cra.component';
import { ValiderCraClientFinalComponent } from './components/valider-cra-client-final/valider-cra-client-final.component';
import { WorkflowListComponent } from './components/workflow-list/workflow-list/workflow-list.component';
import { AddWorkflowconsultantComponent } from './components/add-workflowconsultant/add-workflowconsultant/add-workflowconsultant.component';
import { AddWorkflowclientComponent } from './components/add-workflowclient/add-workflowclient/add-workflowclient.component';
import { ListTimesheetComponent } from './components/List-timesheet/list-timesheet/list-timesheet.component';
import { UpdateworkfloqclientComponent } from './components/updateworkfloqclient/updateworkfloqclient/updateworkfloqclient.component';
import { DetailworkflowclientComponent } from './components/detailworkflowclient/detailworkflowclient/detailworkflowclient.component';
import { clientFinalGuard } from '@core/guards/client-final.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'liste-cra',
    pathMatch: 'full',
  },
  {
    path: 'liste-timesheet',
    component: ListTimesheetComponent,
    canActivate: [clientFinalGuard.canActivate]
  },
  {
    path: 'liste-cra',
    component: ListCraClientFinalComponent,
  },
  {
    path: 'detail-timesheet',
    component: DetailsCraCandidatComponent,
    canActivate: [clientFinalGuard.canActivate]
  },
  {
    path: 'liste-cra-mois',
    component: MonthlyListCraComponent,
  },
  {
    path: 'valide-cra',
    component: ValiderCraClientFinalComponent,
  },
  {
    path: 'workflow-Timesheet',
    component: WorkflowListComponent,
    canActivate: [clientFinalGuard.canActivate]
  },
  {
    path: 'ajout-workflowconsultant',
    component: AddWorkflowconsultantComponent,
  },
  {
    path: 'ajout-workflowclient',
    component: AddWorkflowclientComponent,
  },
  {
    path: 'modifierworkflowclient/:id',
    component: UpdateworkfloqclientComponent,
    canActivate: [clientFinalGuard.canActivate]
  },
  {
    path: 'DetailWorkflowclient/:id',
    component: DetailworkflowclientComponent,
    canActivate: [clientFinalGuard.canActivate]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CraClientFinalRoutingModule {}
